import {
  Button,
  Grid,
  IconButton,
  Tab,
  Tabs,
  Tooltip,
} from "@material-ui/core";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import FeedbackIcon from "@material-ui/icons/Feedback";
import React, { useState } from "react";
import DataCell from "../cells/data";
import PanelBase from "./base";

const PanelUI = ({ list }) => {
  const goToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <Grid spacing={3} container>
      {list?.length > 0 ? (
        <>
          {list.map(({ id, attributes: { texto, dataOcorrencia } }) => (
            <DataCell key={id} xs={12} label={dataOcorrencia} value={texto} />
          ))}

          <Tooltip
            title={<span style={{ fontSize: "11px" }}>Ir para o topo</span>}
          >
            <IconButton
              onClick={goToTop}
              children={<ArrowUpwardIcon />}
              style={{ position: "absolute", bottom: "44px", right: "27px" }}
            />
          </Tooltip>
        </>
      ) : (
        <Button
          fullWidth
          disabled={true}
          startIcon={<FeedbackIcon />}
          size="large"
          variant="outlined"
        >
          Não possuímos esse dado
        </Button>
      )}
    </Grid>
  );
};

export default ({ eventosPrecatorio, eventosProcesso, ...restProps }) => {
  const [innerTabValue, setInnerTabValue] = useState(0);
  const [precatorioPage, setPrecatorioPage] = useState(1);
  const [originarioPage, setOriginarioPage] = useState(1);

  return (
    <PanelBase {...restProps}>
      <Tabs
        centered
        indicatorColor="primary"
        variant="fullWidth"
        value={innerTabValue}
        onChange={(_, newVal) => setInnerTabValue(newVal)}
        aria-label="Abas com movimentações, publicações e documentos do precatório e do processo"
      >
        <Tab label="Precatório" />
        <Tab label="Processo originário" />
      </Tabs>

      <PanelBase value={innerTabValue} index={0}>
        <PanelUI
          title="Precatório"
          list={eventosPrecatorio}
          page={precatorioPage}
          setPage={setPrecatorioPage}
        />
      </PanelBase>

      <PanelBase value={innerTabValue} index={1}>
        <PanelUI
          title="Processo originário"
          list={eventosProcesso}
          page={originarioPage}
          setPage={setOriginarioPage}
        />
      </PanelBase>
    </PanelBase>
  );
};
